import client from "services/ngage/api-client";
import {MediaFile} from "types/MediaFile";
import {dateTime} from "services/date";
import {Duration} from "luxon";

/**
 * Transform the given file by deserializing object properties
 *
 * @internal
 * @param file
 */
export function deserialize(file: any): MediaFile {
    if (file.duration) {
        file.duration = Duration.fromDurationLike(
            file.duration > 59? {minute: 0, second: file.duration} : {second: file.duration}
        ).normalize()
    }

    file.created_at = dateTime(file.created_at)
    file.updated_at = dateTime(file.updated_at)

    return file;
}

/**
 * Store one or more files
 *
 * @param files
 */
const store = async (files: FileList) => {
    const data = new FormData()
    Array.from(files).forEach(file => data.append('files[]', file))

    const response = await client.post<Array<MediaFile>>('/files', data, {
        headers: {
            "Content-Type": 'multipart/form-data'
        }
    })

    return response.data ? response.data.map(deserialize) : []
}

const messages = {
    store
}

export default messages;